import * as React from 'react';
import { Hide } from 'ui';
import { View } from '@components/atoms/icons/view';
import { BaseInput } from '../index';

type PasswordInputProps = Omit<React.ComponentProps<typeof BaseInput>, 'type' | 'endAdornment'> & {
	error?: string;
};

export const PasswordInput: React.FC<PasswordInputProps> = ({ error, ...props }) => {
	const [masked, setMasked] = React.useState(true);

	const toggleMask = () => {
		setMasked(masked => !masked);
	};

	const type: string = masked ? 'password' : 'text';

	const icon: React.ReactNode = React.useMemo(() => {
		if (!props.value) {
			return null;
		}

		return masked ? (
			<Hide key="hide-icon" className="text-secondary hover:cursor-pointer" height={20} width={20} />
		) : (
			<View key="view-icon" className="text-secondary hover:cursor-pointer" height={20} width={20} />
		);
	}, [props.value, masked]);

	React.useEffect(() => {
		if (!props.value) {
			setMasked(true);
		}
	}, [props.value]);

	return (
		<div data-testid="auth-password-input">
			<BaseInput
				{...props}
				type={type}
				error={error}
				endAdornment={
					icon ? (
						<button
							type="button"
							onClick={toggleMask}
							className="flex items-center bg-transparent"
							data-testid="auth-password-toggle"
						>
							{icon}
						</button>
					) : undefined
				}
			/>
		</div>
	);
};
